// Estados de un cierre separados por dimensión (misma regla que backend/lib/estadoCierre.js; no se guarda aparte).
//   Resultado: Cuadrado | Faltante | Sobrante | Sin resultado (faltan datos del sistema) — histórico, nunca desaparece.
//   Revisión:  Pendiente de revisar | Revisado | En corrección — la marca Administración (independiente del resultado).
import { toMoney } from '../../utils/numbers';

export function resultadoCierre(c) {
  const t = c?.totales || {};
  if (t.modoEfectivo === 'ventas' || (t.modoFondo && t.efectivoContadoCaja == null && t.efectivoContado == null)) {
    if (t.diferenciaVentasEfectivo == null) return { tipo: 'Sin resultado', monto: null };
    const ventas = Math.round(Number(t.diferenciaVentasEfectivo) * 100) / 100;
    return Math.abs(ventas) < 0.005 ? { tipo: 'Ventas coinciden', monto: 0 }
      : { tipo: 'Diferencia de ventas', monto: Math.abs(ventas) };
  }
  if (t.efectivoEsperado == null || t.diferenciaCaja == null) return { tipo: 'Sin resultado', monto: null };
  const d = Math.round(Number(t.diferenciaCaja) * 100) / 100;
  if (Math.abs(d) < 0.005) return { tipo: 'Cuadrado', monto: 0 };
  return { tipo: d < 0 ? 'Faltante' : 'Sobrante', monto: Math.abs(d) };
}

export function revisionCierre(c) {
  if (c?.estado === 'Corrección') return 'En corrección';
  const r = resultadoCierre(c);
  if (r.tipo === 'Sin resultado') return 'Pendiente de revisar';
  return c?.revisadoAt || r.tipo === 'Cuadrado' || r.tipo === 'Ventas coinciden' ? 'Revisado' : 'Pendiente de revisar';
}

export const textoResultado = (r) => (r.tipo === 'Sin resultado' ? 'Sin datos del sistema' : r.monto ? `${r.tipo} ${toMoney(r.monto)}` : r.tipo);

// Colores con significado: rojo = requiere atención; ámbar = pendiente; verde = completo/revisado; azul = histórico.
export function claseResultado(r, revision) {
  if (r.tipo === 'Cuadrado' || r.tipo === 'Ventas coinciden') return 'completado';
  if (r.tipo === 'Sin resultado') return 'hoy';
  if (revision === 'Revisado') return 'proximo'; // diferencia ya atendida: información, no alarma
  return r.tipo === 'Faltante' ? 'vencido' : 'hoy';
}
export const claseRevision = { 'Pendiente de revisar': 'hoy', Revisado: 'completado', 'En corrección': 'parcial' };
